/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import _slice from 'lodash/slice';
import _last from 'lodash/last';
import _reduce from 'lodash/reduce';
import _filter from 'lodash/filter';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../constants';

export default (set, get) => set(
  produce(
    get(),
    (draft) => {
      if (!draft.design) {
        draft.design = {};
      }
      const productsState = draft.design.products;
      const target = _last(productsState);

      if (target?.choiceBundle) {
        const updateProductsState = _reduce(draft.design.products, (prev, curr) => {
          prev.push({
            ...curr,
            choiceBundle: curr?.choiceBundle?.id === target?.choiceBundle?.id
              ? null
              : curr.choiceBundle
          });
          return prev;
        }, []);

        const filteredBundlesAdded = _filter(
          draft.bundles.added,
          (bundleAdded) => bundleAdded.bundleId !== target?.choiceBundle?.id
        );

        draft.bundles.added = filteredBundlesAdded;
        draft.design.products = _slice(updateProductsState, 0, -1);
        draft.design.selectedProduct = null;
        logNewRelicCustom(NEW_RELIC_EVENTS.BUNDLE_REMOVED_UNDO, target?.choiceBundle);
        return draft;
      }
      if (!productsState?.length) {
        draft.bundles.added = [];
      }

      draft.design.products = _slice(productsState, 0, -1);
      draft.design.selectedProduct = null;

      const enhancedTarget = {
        ...target,
        ...(draft.design?.isFromPip && { isFromPip: true })
      };

      logNewRelicCustom(NEW_RELIC_EVENTS.PRODUCT_REMOVED_UNDO, enhancedTarget);
      return draft;
    }),
  false,
  { type: 'UNDO' }
);
